
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { PhoneCall } from 'lucide-react';

interface ServiceCtaProps {
  serviceName: string;
}

const ServiceCta = ({ serviceName }: ServiceCtaProps) => {
  return (
    <section className="py-16 bg-pkearth-900 relative">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557429287-b2e26467fc2b?q=80&w=2067&auto=format&fit=crop')] bg-cover bg-center opacity-20"></div>
      <div className="absolute inset-0 bg-pkearth-900/70"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-white">
            Ready to Elevate Your Outdoor Space?
          </h2>
          <p className="text-xl text-pkearth-100 mb-10">
            Contact PK Landscape Associates today to discuss your {serviceName.toLowerCase()} needs
            and schedule a professional consultation.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="bg-white text-pkearth-900 hover:bg-pkearth-100">
              <Link to="/contact">
                Request a Quote
              </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-white text-white hover:bg-white/10">
              <a href="tel:+12034453594">
                <PhoneCall className="mr-2 h-4 w-4" />
                (203) 445-3594
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCta;
